import styles from './styles.css';

export interface ICommunicationLinkProps {
  href: string;
  children: React.ReactNode;
  testId?: string;
}

export const CommunicationInlineLink: React.FC<ICommunicationLinkProps> = props => {
  return (
    <a target="_blank" rel="noreferrer" href={props.href} className={styles['link']} data-testid={props.testId}>
      {props.children}
    </a>
  );
};

CommunicationInlineLink.displayName = 'CommunicationInlineLink';
